<div class="redirections-container">
    <div class="page-top-banner">
        <div class="title">État redirections</div>

        <div class="action-zone">
            <mat-form-field appearance="fill" style="width: 100%;">
                <mat-label>Plateforme :</mat-label>
                <mat-select [(ngModel)]="platform" (ngModelChange)="onPlatformChange()">
                    <mat-option value="Centrex NG">Centrex NG</mat-option>
                    <mat-option value="Centrex Enreach">Centrex Enreach</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="table-container">
        <form class="filters-form">
            <div class="mat-elevation-z8 general-table">
                <h2 class="table-title">Règles d’installation</h2>

                <table mat-table class="default-table" [dataSource]="filteredInstallationDataSource" matSort>

                    <!-- ID -->
                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Nom</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput [(ngModel)]="installationFilters.id" name="id"
                                        (keyup)="applyInstallationFilters()" />
                                    <button mat-icon-button matSuffix
                                        (click)="installationFilters.id = ''; applyInstallationFilters()">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let rule">{{ rule.id }}</td>
                    </ng-container>

                    <!-- Assigné à -->
                    <ng-container matColumnDef="assignedTo">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Assigné à</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput [(ngModel)]="installationFilters.assignedTo" name="assignedTo"
                                        (keyup)="applyInstallationFilters()" />
                                    <button mat-icon-button matSuffix
                                        (click)="installationFilters.assignedTo = ''; applyInstallationFilters()">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let rule">{{ rule.extensionId }}</td>
                    </ng-container>

                    <!-- Active -->
                    <ng-container matColumnDef="active">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Active</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput [(ngModel)]="installationFilters.active" name="active"
                                        (keyup)="applyInstallationFilters()" />
                                    <button mat-icon-button matSuffix
                                        (click)="installationFilters.active = ''; applyInstallationFilters()">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let rule">
                            <span class="status" [ngClass]="rule.enabled ? 'status-yes' : 'status-no'">
                                {{ rule.enabled ? 'oui' : 'non' }}
                            </span>
                        </td>
                    </ng-container>


                    <!-- Type -->
                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Type</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput [(ngModel)]="installationFilters.type" name="type"
                                        (keyup)="applyInstallationFilters()" />
                                    <button mat-icon-button matSuffix
                                        (click)="installationFilters.type = ''; applyInstallationFilters()">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let rule">{{ rule.ringState }}</td>
                    </ng-container>

                    <!-- Destination -->
                    <ng-container matColumnDef="target">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Destination</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput [(ngModel)]="installationFilters.target" name="target"
                                        (keyup)="applyInstallationFilters()" />
                                    <button mat-icon-button matSuffix
                                        (click)="installationFilters.target = ''; applyInstallationFilters()">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let rule">{{ rule.target }}</td>
                    </ng-container>

                    <!-- Programmation -->
                    <ng-container matColumnDef="calendar">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Programmation</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput [(ngModel)]="installationFilters.calendar" name="calendar"
                                        (keyup)="applyInstallationFilters()" />
                                    <button mat-icon-button matSuffix
                                        (click)="installationFilters.calendar = ''; applyInstallationFilters()">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let rule">{{ rule.calendarDisplay || '' }}</td>
                    </ng-container>

                    <!-- Temps max -->
                    <ng-container matColumnDef="ringSeconds">
                        <th mat-header-cell *matHeaderCellDef>Temps max</th>
                        <td mat-cell *matCellDef="let rule">{{ rule.ringSeconds }}</td>
                    </ng-container>

                    <!-- Actions -->
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef>Actions</th>
                        <td mat-cell *matCellDef="let rule">
                            <div class="actions-cell">
                                <button mat-icon-button (click)="onView(rule)">
                                    <mat-icon>visibility</mat-icon>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>

                <h2 class="table-title">Règles par extension</h2>

                <table mat-table class="default-table" [dataSource]="filteredExtensionDataSource" matSort>

                    <!-- ID -->
                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Nom</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput [(ngModel)]="extensionFilters.id" name="id-extension"
                                        (keyup)="applyExtensionFilters()" />
                                    <button mat-icon-button matSuffix
                                        (click)="extensionFilters.id=''; applyExtensionFilters()">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let rule">{{ rule.id }}</td>
                    </ng-container>

                    <!-- Assigné à -->
                    <ng-container matColumnDef="assignedTo">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Assigné à</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput [(ngModel)]="extensionFilters.assignedTo"
                                        name="assignedTo-extension" (keyup)="applyExtensionFilters()" />
                                    <button mat-icon-button matSuffix
                                        (click)="extensionFilters.assignedTo=''; applyExtensionFilters()">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let rule">{{ rule.extensionId }}</td>
                    </ng-container>

                    <!-- Active -->
                    <ng-container matColumnDef="active">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Active</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput [(ngModel)]="extensionFilters.active" name="active-extension"
                                        (keyup)="applyExtensionFilters()" />
                                    <button mat-icon-button matSuffix
                                        (click)="extensionFilters.active=''; applyExtensionFilters()">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let rule">
                            <span class="status" [ngClass]="rule.enabled ? 'status-yes' : 'status-no'">
                                {{ rule.enabled ? 'oui' : 'non' }}
                            </span>
                        </td>
                    </ng-container>

                    <!-- Type -->
                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Type</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput [(ngModel)]="extensionFilters.type" name="type-extension"
                                        (keyup)="applyExtensionFilters()" />
                                    <button mat-icon-button matSuffix
                                        (click)="extensionFilters.type=''; applyExtensionFilters()">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let rule">{{ rule.ringState }}</td>
                    </ng-container>

                    <!-- Destination -->
                    <ng-container matColumnDef="target">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Destination</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput [(ngModel)]="extensionFilters.target" name="target-extension"
                                        (keyup)="applyExtensionFilters()" />
                                    <button mat-icon-button matSuffix
                                        (click)="extensionFilters.target=''; applyExtensionFilters()">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let rule">{{ rule.target }}</td>
                    </ng-container>

                    <!-- Programmation -->
                    <ng-container matColumnDef="calendar">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Programmation</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput [(ngModel)]="extensionFilters.calendar" name="calendar-extension"
                                        (keyup)="applyExtensionFilters()" />
                                    <button mat-icon-button matSuffix
                                        (click)="extensionFilters.calendar=''; applyExtensionFilters()">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let rule">
                            {{ rule.calendarDisplay || '' }}
                        </td>
                    </ng-container>

                    <!-- Temps max -->
                    <ng-container matColumnDef="ringSeconds">
                        <th mat-header-cell *matHeaderCellDef>Temps max</th>
                        <td mat-cell *matCellDef="let rule">{{ rule.ringSeconds }}</td>
                    </ng-container>

                    <!-- Actions -->
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef>Actions</th>
                        <td mat-cell *matCellDef="let rule">
                            <div class="actions-cell">
                                <button mat-icon-button (click)="onView(rule)">
                                    <mat-icon>visibility</mat-icon>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>

            </div>
        </form>
    </div>
</div>

<mat-paginator [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons></mat-paginator>

<ngx-spinner name="spinner" bdColor="rgba(0, 0, 0, 0.2)" size="medium" color="#00D2B4" type="timer"
    [fullScreen]="true"></ngx-spinner>